/**
 * Module Api Schema - Menu Registry
 */
import { PAGE_URLS, PERMISSION_KEYS } from "../constants";

const apiSchemaMenuRegistry = {
    api_schema_playground: {
        label: "API Playground",
        link: PAGE_URLS.API_PLAYGROUND,
        key: PAGE_URLS.API_PLAYGROUND,
        resourceKey: PERMISSION_KEYS.API_PROXY
    },
    api_schema_project: {
        label: "API Projects",
        link: PAGE_URLS.API_PROJECT,
        key: PAGE_URLS.API_PROJECT,
        resourceKey: PERMISSION_KEYS.API_PROJECT
    },
    api_schema_environment: {
        label: "Environments",
        link: PAGE_URLS.API_ENVIRONMENT,
        key: PAGE_URLS.API_ENVIRONMENT,
        resourceKey: PERMISSION_KEYS.API_ENVIRONMENT
    },
    api_schema_saved_request: {
        label: "Saved Requests",
        link: PAGE_URLS.API_SAVED_REQUEST,
        key: PAGE_URLS.API_SAVED_REQUEST,
        resourceKey: PERMISSION_KEYS.API_SAVED_REQUEST
    },
    api_schema_history: {
        label: "Request History",
        link: PAGE_URLS.API_REQUEST_HISTORY,
        key: PAGE_URLS.API_REQUEST_HISTORY,
        resourceKey: PERMISSION_KEYS.API_REQUEST_HISTORY
    }
};

export default apiSchemaMenuRegistry;
